/**
 * API origin for Axios and the home screen footer.
 * Dev (`npm run dev`) uses .env.dev; production build uses .env.prod
 * Set both in `.env` (Vite exposes only `VITE_*` to client code).
 */
export const API_BASE_URL = import.meta.env.VITE_BASE_API_URL;
